import { compact } from 'lodash-es'
import exampleEvent from './ExampleEvent'
import springPromotion2026Event from './SpringPromotion2026'

/**
 * Growth event registry
 *
 * The earlier an event is in the list, the higher priority its slot contents
 * have to be rendered.
 */
// oxfmt-ignore
export default compact([
  springPromotion2026Event,
  import.meta.env.DEV && exampleEvent,
])
